'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import LearningHeader from './components/LearningHeader';
import LearningDashboard from './components/LearningDashboard';

export default function LearningAreaPage() {
  return (
    <AppLayout>
      <div className="pt-14 lg:pt-0 min-h-screen bg-background">
        <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-12 py-6 space-y-6">
          <LearningHeader />
          <LearningDashboard />
        </div>
      </div>
    </AppLayout>
  );
}
